export default function ({ ...props }) {
    return (
        <svg {...props} width="32100" height="18535" viewBox="0 0 32100 18535" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32100 0H0V18535H32100V0ZM20356.4 6616.41H17923.7L13717.5 9803.48H14638.2L9988.97 13652L17953.6 8877.31H17022.3L20356.4 6616.41ZM12736.4 6616.41H14672.8L15662 7938L14428 8875.99L12736.4 6616.41ZM18582.9 11839.1H16646.4L15695.2 10569.4L17030.9 9766.05L18582.9 11839.1Z"
                fill="black"
            />
        </svg>
    );
}
